import router from 'platfi-service-router';

import Auth from 'utils/Auth';
import Session from '../utils/Session';
import Auth0SDK from '../utils/Auth0SDK';
import AuthApiClient from './utils/AuthApiClient';

const services = {
  routerService: router.init({
    BASE_URL_ACTIVITY_API: window._env_.ACTIVITY_API_DOMAIN,
    BASE_URL_CONTENT_API: window._env_.CONTENT_API_DOMAIN,
    BASE_URL_DASHBOARD_API: window._env_.DASHBOARD_API_DOMAIN,
    BASE_URL_LEARNING_API: window._env_.LEARNING_API_DOMAIN,
    BASE_URL_LEARNING_SPA: window._env_.LEARNING_SPA_DOMAIN,
    BASE_URL_MARKETPLACE_API: window._env_.MARKETPLACE_API_DOMAIN,
    BASE_URL_MONITOR_API: window._env_.MONITOR_API_DOMAIN,
    BASE_URL_REPORT_API: window._env_.REPORT_API_DOMAIN,
    BASE_URL_PLATFORM_API: window._env_.PLATFORM_API_DOMAIN,
    BASE_URL_CALLBACKS_API: window._env_.CALLBACKS_API_DOMAIN,
    BASE_URL: window._env_.API_DOMAIN,
  }),
  authApiService: AuthApiClient,
  sessionService: Session,
  // On production build we don't load the Auth service, since Auth0 lock is not used yet.
  authService: new Auth(),
  auth0SDK: Auth0SDK,
};

export default services;
